import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },

  {
    path: "/game",
    name: "Game",
    component: () => import("../views/Game.vue"),
    children: [
      {
        path: ":side(neutral):id([0-9]+)",
        component: () => import("../components/GameWindow.vue"),
        props: true
      }
    ]
  },
  {
    path: "/graphic",
    name: "Graphic",
    component: () => import("../views/Graphic.vue"),
    children: [
      {
        path: ":side(dark|light):id([0-9]+)",
        component: () => import("../components/GraphicWindow.vue"),
        props: true
      }
    ]
  },
  {
    path: "/music",
    name: "Music",
    component: () => import("../views/Music.vue"),
    children: [
      {
        path: ":side(dark|light):id([0-9]+)",
        component: () => import("../components/MusicWindow.vue"),
        props: true
      }
    ]
  },
  {
    path: "/story",
    name: "Story",
    component: () => import("../views/Story.vue"),
    children: [
      {
        path: ":side(dark|light):id([0-9]+)",
        component: () => import("../components/StoryWindow.vue"),
        props: true
      }
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  base: "/qvf", // 本番環境でｙはこっち
  routes,
});

export default router;
